// Marks the page as driven from the keyboard, so a container can take its hover look while
// something inside it holds keyboard focus. A `:has(:focus-visible)` selector says the same thing,
// but Chromium re-checks every such rule on each DOM change, and with a few dozen of them a chart's
// first draw (which adds a node and reads a style for every label) went from ~0.1s to ~2s.
export const KEYBOARD_MODE_CLASS = 'keyboard-mode'

// the browser's own rule for :focus-visible: a key pressed without a command modifier means keyboard
// navigation, a pointer press means the pointer
const onKeyDown = event => {
  if (event.metaKey || event.ctrlKey || event.altKey) return
  document.documentElement.classList.add(KEYBOARD_MODE_CLASS)
}

const onPointerDown = () => {
  document.documentElement.classList.remove(KEYBOARD_MODE_CLASS)
}

let installed = false

export function installKeyboardMode() {
  if (installed) return
  installed = true

  // capture, so a handler that stops the event still leaves the mode right
  document.addEventListener('keydown', onKeyDown, true)
  document.addEventListener('pointerdown', onPointerDown, true)
}

export function uninstallKeyboardMode() {
  installed = false
  document.removeEventListener('keydown', onKeyDown, true)
  document.removeEventListener('pointerdown', onPointerDown, true)
  document.documentElement.classList.remove(KEYBOARD_MODE_CLASS)
}
